import cx from 'classnames';
import styles from 'styles/shop/product.module.css';
import { useProduct, useShop } from 'components/products/context';
import { getCurrency, getFlat } from 'ui/utils';
import { useSelectedVariant } from 'components/products/hooks';
import { useLanguageLoader } from 'contexts/language';
import DisablePopup from 'components/store/common/DisablePopup';
import ProductTags from 'components/store/common/ProductTags';
const speedIcon = '/images/store/speed.svg';
const stockIcon = '/images/store/stock.svg';

export function ProductDetails() {
  const product = useProduct();
  const selectedVariant = useSelectedVariant();
  const shop = useShop();
  const lang = useLanguageLoader();

  const isOOS = product.status === 'out of stock';
  const leftInStock = `${lang('store.words.only')} ${selectedVariant?.available} ${lang('store.words.leftInStock')}`;
  const oosText = lang('store.words.outOfStock');

  const shippingTimeFrom = product?.shippingTime?.from?.value || shop?.delivery?.shippingTime?.from?.value;
  const shippingTimeTo = product?.shippingTime?.to?.value || shop?.delivery?.shippingTime?.to?.value;
  const shippingTimeType = product?.shippingTime?.from?.type || shop?.delivery?.shippingTime?.from?.type;

  const price = (amount, currency) => {
    const i = getCurrency(amount, currency)
    if (i.includes('.')) {
      const [number, decimal] = i.split('.')
      return (<span>{number + '.'}<span className={styles.decimal}>{(decimal)}</span></span>)
    }
    return <span>{i}</span>
  }

  return (
    <div>
      <DisablePopup blocked={shop?.blocked} />
      <div className={cx('fs12 vertical', styles.title)}>
        {product.title}
      </div>
      <div className={styles.price}>
        {price(selectedVariant?.discountedAmount, product?.shop?.currency)}
        {selectedVariant?.discountedAmount !== selectedVariant?.amount && (
          <span className={cx('strikeLine paddingSLeft', styles.primary2)}>
            {price(selectedVariant?.amount, product?.shop?.currency)}
          </span>
        )}
        {selectedVariant?.discountedAmount !== selectedVariant?.amount && (
          <span className={cx('paddingSLeft', styles.green)}>{getFlat(selectedVariant)}</span>
        )}
      </div>

      <div className={styles.priceU}>
        {product?.unit?.value && product?.unit?.type && (
          <span>
            {`Per ${product?.unit?.value} ${product?.unit?.type}`}
          </span>
        )}
      </div>
      {shippingTimeFrom && (
        <div className={styles.speed}>
          <img className={styles.stockIcon} src={speedIcon} alt="" />
          {`${lang('store.headings.estimatedDeliveryTime')}: ${shippingTimeFrom}
              - ${shippingTimeTo} ${shippingTimeType}`}
        </div>
      )}
      {selectedVariant?.isAvailable
        && selectedVariant?.availableType === 'finite'
        && selectedVariant?.available < 10
        && !isOOS
        && (
          <div className={styles.stock}>
            <img className={styles.stockIcon} src={stockIcon} alt="" />
            {leftInStock}
          </div>
        )}
      {isOOS && (
        <div className={styles.stock}>
          <img className={styles.stockIcon} src={stockIcon} alt="" />
          {oosText}
        </div>
      )}
      <ProductTags product={product} shop={shop}/>
    </div>
  );
}
